export default "__VITE_ASSET__DUFC6ghV__"